import React from 'react';
import NotFoundPage from './pages/PageNotFoundDataRoom';
import { DataRoomRoute } from './models/Route';
import { Navigate } from 'react-router-dom';
import MembersRouter, { membersRoutes } from './subrouters/Members';
import Dashboard from './pages/Dashboard';
import SettingsRouter from './subrouters/Settings';
import dataroomSettingsRoutes from './subrouters/Settings/routes';
import DocumentsPage from './pages/Documents';
import Questions, { questionsRoutes } from './pages/Questions';
import ReportsRouter, { reportsRoutes } from './subrouters/Reports';
import RFIRouter, { rfiRoutes } from './subrouters/RFI';
import RedirectToNewQuestionsRouter from './components/RedirectToNewQuestionsRouter';
import BuySideTeams from './pages/BuySideTeams';
import { shareableLinksRoutes } from './subrouters/ShareableLinks';
import ShareableLinks from './subrouters/ShareableLinks/ShareableLinks.router';
import WaitingRoom from './pages/WaitingRoom';
import DataRoomNdas from './pages/DataRoomNdas';

export default [
  {
    path: 'dashboard',
    element: Dashboard,
  },
  {
    path: 'members',
    element: MembersRouter,
    routes: membersRoutes,
  },
  {
    path: 'questions-and-answers/*',
    element: RedirectToNewQuestionsRouter,
  },
  {
    path: 'frequently-asked-questions/*',
    element: RedirectToNewQuestionsRouter,
  },
  {
    path: 'questions',
    element: Questions,
    routes: questionsRoutes,
  },
  {
    path: 'reports',
    element: ReportsRouter,
    routes: reportsRoutes,
  },
  {
    path: 'settings',
    routes: dataroomSettingsRoutes,
    element: SettingsRouter,
  },
  {
    path: 'documents/:documentId',
    element: DocumentsPage,
  },
  {
    path: 'documents',
    element: DocumentsPage,
  },
  {
    path: 'rfi',
    element: RFIRouter,
    routes: rfiRoutes,
  },
  {
    path: 'team',
    element: BuySideTeams,
  },
  {
    path: 'waiting-room',
    element: WaitingRoom,
  },
  {
    path: 'shareable-links',
    routes: shareableLinksRoutes,
    element: ShareableLinks,
  },
  {
    path: 'ndas',
    element: DataRoomNdas,
  },
  {
    index: true,
    element: <Navigate to="dashboard" replace />,
  },
  { path: '*', element: NotFoundPage },
] as Array<DataRoomRoute>;
